import axios from 'axios';
import actions from './actions';
import config from '../../../../config/index';
const _ = require('lodash');

const prepareDisclosureAction = actions.Creators.prepareDisclosure;
const onSigningEventAction = actions.Creators.onSigningEvent;
const handleSignDisclosureErrorAction = actions.Creators.handleSignDisclosureError;

const prepareDisclosure = (state, submissionUuid, contactUuid) => async dispatch => {
    let params = {};
    params.submissionUuid = submissionUuid;
    params.contactUuid = contactUuid;
    params.state = state;

    console.log('submissionUuid = ', submissionUuid);
    console.log('contactUuid = ', contactUuid);   

    const response = await axios.post(
        config.apiUrl + '/fundingPlatformPublic/signDisclosure/prepareDisclosure',
        params
    );

    const contactSigningStatus =
        _.keyBy(
            response.data.contactsSigningStatusDisclosure,
            'contactUuid'
        )[contactUuid];

    console.log('contactsSigningStatusDisclosure = ',
        response.data.contactsSigningStatusDisclosure
    );

    console.log('contactSigningStatus = ', contactSigningStatus);

    if (contactSigningStatus) {
        contactSigningStatus.eventListener = '';
    }

    dispatch(
        prepareDisclosureAction({
            contactsSigningStatus: response.data.contactsSigningStatusDisclosure,
            contactSigningStatus: contactSigningStatus
        })
    );

    return contactSigningStatus;
};

const onSigningEvent = (params) => async dispatch => {
	let contactUuid = params.contactUuid;
	let submissionUuid = params.submissionUuid;

	let response = '';
	response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signDisclosure/onSigningEvent', params);

	let contactSigningStatus = _.keyBy(response.data.contactsSigningStatus, 'contactUuid')[contactUuid];
	contactSigningStatus.eventListener = response.data.event
	try {
		setTimeout(async () => {
			if (contactSigningStatus.status && contactSigningStatus.status === "Signed" && 
				contactSigningStatus.signatureId && contactSigningStatus.signatureId!=='') {
					console.table({signatureId: contactSigningStatus.signatureId, submissionUuid: submissionUuid, status: contactSigningStatus.status});
					await axios.get(config.apiUrl + `/webhooks/helloSign/uploadFile?submissionUuid=${submissionUuid}&signatureId=${contactSigningStatus.signatureId}&type=Disclosure`);
			}
		}, 10000);
        dispatch(onSigningEventAction({contactsSigningStatus: response.data.contactsSigningStatus, contactSigningStatus: contactSigningStatus}));
	} catch(error) {
		dispatch(error);
	}

    return;
}
const handleSignDisclosureError = () => async dispatch => {
	try {
        dispatch(handleSignDisclosureErrorAction());
	} catch(error) {
		dispatch(error);
	}
    return;
}

export default {
    prepareDisclosure,
	onSigningEvent,
	handleSignDisclosureError
  }